import PropTypes from 'prop-types'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../common/html/element'

const TextLink = ({ value, onClick }) => {
  return (
    <Element
      className="cursorPointer"
      style={{ color: '#2C73E8' }}
      onClick={onClick}
    >
      <Translate value={value} />
    </Element>
  )
}

TextLink.propTypes = {
  value: PropTypes.string.isRequired,
  onClick: PropTypes.func,
}

export default TextLink
